import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  addEmailLog,
  addPOChange,
  getPurchaseOrderlineItemsByPOID,
  getRevisedPODetails,
  shouldMailSendToSupplier,
} from "../services/dataService";
import BasicEditableTable from "./table/BasicEditableTable";
import { PO_UPDATE_COLUMNS, PO_REVISED_COLUMNS } from "../columns/columns";
import { poUpdateEditableCell } from "./table/cell/poUpdateEditableCell";
import { sendEmail } from "../services/emailService";
import { poUpdateEmailTemplate } from "../email-templates/templateGenerator";
import { today } from "../manager/dateManager";
import { toast } from "react-toastify";
import BasicTable from "./table/BasicTable";
import moment from "moment";
import { getUser } from "../services/authService";
import { devCCEmails, revisedPOCCMailLive } from "../config/emailRecipient";
import config from "../config/envConfig";

function POUpdateModal({ handleClose, POID, selectedPO }) {
  const [originalPODetailInfo, setOriginalPOPODetailInfo] = useState([]);
  const [poDetailInfo, setPODetailInfo] = useState([]);
  const [loading, setLoading] = useState(false);
  const [revisedPOData, setRevisedPOData] = useState([]);
  const podate = moment(selectedPO?.PODate).format("MMM YY");
  const user = getUser();

  const updatePOData = (rowIndex, columnId, value) => {
    if (columnId === "DueDate") {
      setPODetailInfo(
        poDetailInfo.map((item) => {
          return {
            ...item,
            DueDate: value,
          };
        })
      );
    } else {
      setPODetailInfo((old) =>
        old.map((row, index) => {
          if (index === rowIndex) {
            return {
              ...old[rowIndex],
              [columnId]: value,
            };
          }
          return row;
        })
      );
    }
  };

  useEffect(() => {
    async function getPODetails(poId) {
      try {
        const infoResponse = await getPurchaseOrderlineItemsByPOID(poId);
        setPODetailInfo(infoResponse.data);
        setOriginalPOPODetailInfo(infoResponse.data);

        const newQtyResponse = await getRevisedPODetails(poId);
        setRevisedPOData(newQtyResponse.data);
      } catch (error) {}
    }
    if (POID) {
      getPODetails(POID);
    }
  }, [POID]);
  const sendRevisedPOToSupplier = async (poNumber, poid) => {
    setLoading(true);
    const shouldMailSend = await shouldMailSendToSupplier(poid);

    if (shouldMailSend) {
      await sendEmail({
        receiverAddress: selectedPO.SupplierEmails
          ? selectedPO.SupplierEmails
          : selectedPO.CCMail,
        cc: config.env === "development" ? devCCEmails : revisedPOCCMailLive,
        bcc: selectedPO.BCCMail.split(","),
        receiverName: selectedPO?.SupplierShortName,
        subject: `${selectedPO?.SupplierShortName}-${selectedPO.PONumber}/${podate} - Revised Purchase Order Against PO- ${poNumber}`,
        HTML: poUpdateEmailTemplate(
          originalPODetailInfo,
          poDetailInfo,
          poNumber
        ),
        attachments: [],
        templateId: "2",
        alertTime: today(true),
      });
      setLoading(false);
      toast.success("Updated PO sent");
      await addEmailLog({
        Mailto: selectedPO.SupplierEmails
          ? selectedPO.SupplierEmails
          : selectedPO.CCMail,
        MailCc: selectedPO.CCMail ? selectedPO.CCMail : "",
        MailSubject: `${selectedPO?.SupplierShortName}-${selectedPO.PONumber}/${podate} - Revised Purchase Order Against PO- ${poNumber}`,
        FormName: "PO Change",
        FunctionalityName: "PO update dialog ",
        TriggerDatetime: today(true),
        UId: user.userDetails.UserId,
        HostName: "Test HostName",
        ProjectName: "ImpexPortal",
      });
      handleClose();

      const poHistory = [];
      originalPODetailInfo.forEach((item, index) => {
        if (
          item.Qty !== poDetailInfo[index].Qty ||
          item.DueDate !== poDetailInfo[index].DueDate
        ) {
          poHistory.push({
            POID: item.POID,
            PONumber: item.PONumber,
            PartNo: item.PartNo,
            OldQty: item.Qty,
            NewQty: poDetailInfo[index].Qty,
            OldDueDate: item.DueDate,
            NewDueDate: poDetailInfo[index].DueDate,
          });
        }
      });
      try {
        if (poHistory.length) {
          await addPOChange(poHistory);
        }
      } catch (error) {
        toast.error("Please check details");
      }
    }
  };
  return (
    <Dialog p={3} fullWidth open={Boolean(POID)} onClose={handleClose}>
      <DialogTitle p={2}>
        {poDetailInfo[0]
          ? `Update request for ${poDetailInfo[0].PONumber}`
          : " "}

        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          pt: "16px !important",
        }}
      >
        <Grid container spacing={2} p={2}>
          <BasicEditableTable
            columns={PO_UPDATE_COLUMNS}
            data={poDetailInfo}
            updateLocalState={updatePOData}
            defaultColumn={poUpdateEditableCell}
          />
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} sx={{ fontSize: "12px" }}>
          Close
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            sendRevisedPOToSupplier(poDetailInfo[0].PONumber, poDetailInfo[0].POID);
          }}
          disabled={loading}
          sx={{ fontSize: "12px" }}
        >
          {loading ? "Sending.." : "Send"}
        </Button>
      </DialogActions>
      <Divider></Divider>
      {revisedPOData.length !== 0 && (
        <>
          <DialogTitle p={2}>
            {poDetailInfo[0]
              ? `Revised order request history for ${poDetailInfo[0].PONumber}`
              : " "}
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2} p={2}>
              <BasicTable columns={PO_REVISED_COLUMNS} data={revisedPOData} />
            </Grid>
          </DialogContent>
        </>
      )}
    </Dialog>
  );
}

export default POUpdateModal;
